import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: Number }

  connect() {
    console.log(`🔄 Auto-refresh controller connected with ${this.intervalValue}ms interval`)
    this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  startRefreshing() {
    if (this.intervalValue > 0) {
      this.timer = setInterval(() => {
        this.refresh()
      }, this.intervalValue)
    }
  }

  stopRefreshing() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  refresh() {
    // Get the turbo frame element
    const frame = this.element.closest('turbo-frame')
    if (frame && frame.src) {
      console.log(`🔄 Auto-refreshing frame: ${frame.id}`)
      
      // Reload the frame
      frame.reload()
    }
  }

  // Manual refresh method that can be called by other controllers
  refreshNow() {
    this.refresh()
  }
}